// React
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// Locales
import translate from 'locales/i18n';
// Material UI
import { withStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import IconButton from '@mui/material/IconButton';
import CopyIcon from '@mui/icons-material/FileCopy';
import ClearIcon from '@mui/icons-material/Clear';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import AlertAction from 'actions/AlertAction';

class DialogExportAccount extends React.PureComponent {
    copyCodeToClipboard = text => {
        navigator.clipboard.writeText(text);
        AlertAction.open('success', translate.i18n('SUCCESS_COPY'), 'top-right');
    };

    render() {
        const { fullScreen, classes, close, open, users } = this.props;

        return (
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={close}
                disableRestoreFocus={true}
                aria-labelledby='responsive-dialog-title'
                classes={{
                    paper: classes.dialogPaper
                }}
            >
                <IconButton color='secondary' onClick={close} className={classes.closeButton}>
                    <ClearIcon />
                </IconButton>
                <DialogTitle id='responsive-dialog-title'>{translate.i18n('USERS_LIST')}</DialogTitle>
                <DialogContent className={classNames(!fullScreen && classes.dialogContentNotFullScreen, classes.dialogContent)}>
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    <div className={classes.loginContainer}>
                                        <div ref={(text) => this.login = text} className={classes.login}>{translate.i18n('LOGIN')}</div>
                                        <IconButton title={translate.i18n('COPY_TO_CLIPBOARD')} onClick={() => this.copyCodeToClipboard(users.map(u => u.login).join(','))}>
                                            <CopyIcon fontSize='small' />
                                        </IconButton>
                                    </div></TableCell>
                                <TableCell align='center'>{translate.i18n('FIRSTNAME')}</TableCell>
                                <TableCell align='center'>{translate.i18n('LASTNAME')}</TableCell>
                                <TableCell align='center'>{translate.i18n('USER_BLOCKED')}</TableCell>
                                <TableCell align='center'>{translate.i18n('MAX_CONNECTION')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {users.map((user) =>
                                <TableRow key={user.login}>
                                    <TableCell component='th' scope='row'>
                                        <div className={classes.loginContainer}>
                                            <div ref={(text) => this.login = text} className={classes.login}>{user.login}</div>
                                            <IconButton title={translate.i18n('COPY_TO_CLIPBOARD')} onClick={() => this.copyCodeToClipboard(user.login)}>
                                                <CopyIcon fontSize='small' />
                                            </IconButton>
                                        </div>
                                    </TableCell>
                                    <TableCell align='center'>{user.first_name}</TableCell>
                                    <TableCell align='center'>{user.last_name}</TableCell>
                                    <TableCell align='center'>{user.is_blocked ? translate.i18n('YES') : translate.i18n('NO')}</TableCell>
                                    <TableCell align='center'>{user.max_connection}</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </DialogContent>
            </Dialog>
        );
    }
}

DialogExportAccount.propTypes = {
    classes: PropTypes.object.isRequired,
    open: PropTypes.bool,
    exportData: PropTypes.func,
    users: PropTypes.array,
    close: PropTypes.func,
    fullScreen: PropTypes.bool,
};

const styles = () => ({
    closeButton: {
        position: 'absolute',
        right: '2px',
        top: '2px'
    },
    dialogPaper: {
        maxWidth: 'none'
    },
    loginContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    login: {
        marginRight: '6px'
    }
});

export default withStyles(styles)(DialogExportAccount);
